<template>
    <div>

        <Header icon="fad fa-pencil-ruler" title="Upravit uživatele">
            <template #buttons>
                <BackLinkButton to="/setup/users"/>
            </template>
        </Header>

        <UserForm
            :request="request"
            :is-processing="isUpdating"
            v-on:submitted="onSubmitted"
        />

    </div>
</template>

<script>
import {mapGetters} from "vuex"
import BackLinkButton from "../../Common/UI/Button/BackLinkButton.vue"
import Header from "../../Common/UI/Header.vue"
import UserForm from "./Component/UserForm.vue"
import UserRequest from "../../../NewModel/User/Request/UserRequest"

export default {

    components: {
        BackLinkButton,
        Header,
        UserForm,
    },

    computed: {
        ...mapGetters({
            user: 'user/getUser',
            isUpdating: 'user/isUpdating',
        }),
    },

    data() {
        return {
            request: new UserRequest(),
        }
    },

    mounted() {
        this.request = UserRequest.from(this.user)
    },

    methods: {

        onSubmitted(request) {
            this.$store.dispatch("user/updateUser", {
                id: this.user.id,
                request: request,
            })
                .then(() => {
                    this.successMessage('Úspěšně uloženo!')
                    this.$router.push({name: 'setup_user_list'})
                })
                .catch((err) => {
                    this.warningMessage(err.response.message)
                })
        },

    },

}
</script>
